<div class="tracking-container" *ngIf="!errorMessage">
	<!-- Left panel -->
	<div class="order-details-wrapper">
		<div class="order-details card">
			<h3>
				<span><i class="fas fa-arrow-left" (click)="goBack()"></i></span>{{ trackingConstants.pageTitle }}
			</h3>
			<div class="order-contact-details">
				<h4>{{ trackingConstants.orderDetailsTitle }}</h4>
				<p class="paragraph">
					<strong>{{ trackingConstants.trackingNumber }}</strong>
					<span class="highlight">{{ deliveryItem?.upi }}</span>
				</p>
				<p class="paragraph">
					<strong>{{ trackingConstants.productDescription }}</strong>
					<span class="highlight">{{ deliveryItem?.item_description }}</span>
				</p>
				<p class="paragraph">
					<strong>{{ trackingConstants.orderFrom }}</strong> <span class="highlight">{{ wismoDetails?.account_name }}</span>
				</p>
				<p class="paragraph">
					<strong>{{ trackingConstants.optedServices }}</strong>
					<span *ngIf="serviceItems.length; else noService">
						<ng-container *ngFor="let s of serviceItems; let last = last">
							<span class="highlight">{{ s.item_description }}</span>
							<span *ngIf="!last"><br /></span>
						</ng-container>
					</span>
				</p>
				<ng-template #noService>
					<span class="highlight">{{ trackingConstants.noOptedService }}</span>
				</ng-template>

				<h4>{{ trackingConstants.contactDetailsTitle }}</h4>
				<p>
					<strong>{{ wismoDetails?.first_name }} {{ wismoDetails?.last_name }}</strong>
				</p>
				<p *ngIf="wismoDetails?.email_address"><i class="fas fa-envelope"></i> {{ wismoDetails?.email_address }}</p>
				<p *ngIf="wismoDetails?.address_line_1 || wismoDetails?.address_line_2 || wismoDetails?.city || wismoDetails?.post_code">
					<i class="fas fa-map-marker-alt"></i> {{ wismoDetails?.address_line_1 }} {{ wismoDetails?.address_line_2 }}
					{{ wismoDetails?.city }} {{ wismoDetails?.post_code }}
				</p>
				<p *ngIf="wismoDetails?.mobile_phone"><i class="fas fa-phone-alt"></i> {{ wismoDetails?.mobile_phone }}</p>
				<p *ngIf="wismoDetails?.contact_phone"><i class="fa fa-user"></i> {{ wismoDetails?.contact_phone }}</p>
				<p *ngIf="wismoDetails?.home_phone"><i class="fa fa-home"></i> {{ wismoDetails?.home_phone }}</p>
				<p *ngIf="wismoDetails?.work_phone"><i class="fa fa-briefcase"></i> {{ wismoDetails?.work_phone }}</p>
			</div>
		</div>
		<button mat-button class="btn mt-4" (click)="onUpdateDetails()" [disabled]="isUpdateBtnDisabled">Update Details</button>
	</div>
	<!-- Right panel -->
	<div class="tracking-timeline">
		<div class="card stepper-card" *ngIf="isShowStepper">
			<kendo-stepper
				class="custom-stepper"
				[steps]="steps"
				stepType="full"
				[(currentStep)]="currentStep"
				[linear]="true"
				(activate)="onStepActivate($event)"
			>
			</kendo-stepper>
		</div>
		<h4>{{ trackingConstants.keepingTrackTitle }}</h4>
		<div>
			<div class="stepper-container card">
				<div class="step-item" *ngFor="let step of verticalsteps; let i = index">
					<div class="step-header">
						<div class="step-date-time">
							<p class="step-date">
								<strong>{{ step.date }}</strong>
							</p>
							<p>{{ step.time }}</p>
						</div>
						<div class="step-connector">
							<div class="step-dot" [class.active]="i <= verticalsteps.length - 1"></div>
							<div class="step-line" *ngIf="i < verticalsteps.length - 1" [class.active]="i < verticalsteps.length - 1"></div>
						</div>
					</div>
					<div class="step-content">
						<p class="activity">
							<strong>{{ trackingConstants.activity }}</strong
							>: {{ step.activity }}
						</p>
						<p class="location">
							<strong>{{ trackingConstants.location }}</strong
							>: {{ step.location }}
						</p>
						<hr />
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
